<template>
  <div class="otherForm">
    <el-dialog title="申诉表单" :visible.sync="dialogVisible" width="1000px" @close="$emit('update:visible', dialogVisible)" v-loading="loading">
      <h3>商户信息</h3>
      <div v-loading="loading">
        <div class="marginLeft">
          <p>
            商户简称：{{ messageForm.fMerchantName }}&nbsp;&nbsp;&nbsp;
            风险来源：{{ fRiskSourceStr }}&nbsp;&nbsp;&nbsp;
            工单号：{{ messageForm.fTicketNumber }}&nbsp;&nbsp;&nbsp;
            处理状态：
            <span v-if="messageForm.auditStatus === 1" class="red">待提交</span>
            <span v-if="messageForm.auditStatus === 2">审核中</span>
            <span v-if="messageForm.auditStatus === 3" class="red">审核未通过</span>
            <span v-if="messageForm.auditStatus === 4" class="green">审核通过</span>
            <span v-if="messageForm.auditStatus === 5" class="red">审核终止</span>&nbsp;&nbsp;
          </p>
          <p>已审次数：{{ messageForm.fMtlVerifyTimes }} &nbsp;&nbsp;&nbsp;<span class="blue">注：每个工单有5次申诉机会，若第五次仍审核不通过，则终止审核。</span></p>
        </div>
        <h3>填写申诉资料</h3>
        <p class="smallFont">请保证资质照片的匹配性，证照齐全且真实有效。</p>
        <el-form ref="appealForm" :model="appealForm" :data="appealForm" :rules="appeal_rules" label-position="top">
          <h4><font class="red">*</font>1、视频：<span class="red" v-if="verifyFailed && disabledItem.videoUrl">（资料未通过审核，请提交正确资料）</span></h4>
          <el-form-item prop="videoUrl">
            <p class="formTips">要求：一个不间断视频,视频时长不低于45秒<br>
              视频内容包含：<br>
              1)每个收款码牌1米左右远距离的视频<br>
              2)商户门头(含门牌号)、营业场所内部、交易场景(服务对象,货物,销售人员在场,收银台等)、营业执照(经营许可证)<br>
              <!-- 备注：个体工商商户或小微商户须提供视频，企业商户无法提供视频的，可提供企业的门头照、营业场所内部照、收银台照片，营业执照照片，并加盖公章 -->
            </p>
            <upload-video-oss
              description="上传视频"
              v-model="appealForm.videoUrl"
              :disabled="verifyFailed && !disabledItem.videoUrl"
              valueName="videoUrl"
              @uploaded="uploadSuccess"></upload-video-oss>
          </el-form-item>
          <h4><font class="red">*</font>2、身份证、银行卡：<span class="red" v-if="verifyFailed && disabledItem.handheldImg || verifyFailed && disabledItem.bankCardFront">（资料未通过审核，请提交正确资料）</span></h4>
          <p class="smallFont">请提交jpg、jpeg或png格式的图片，且单张需小于1MB。</p>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="handheldImg">
                <uploadImg
                  label="收款人手持身份证正面（头像面）照片"
                  :value="appealForm.handheldImg"
                  :required="true"
                  v-model="appealForm.handheldImg"
                  valueName="handheldImg"
                  :readonly="verifyFailed && !disabledItem.handheldImg"
                  :exampleImg="id_eg"
                  @success="uploadSuccess"></uploadImg>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="bankCardFront">
                <uploadImg
                  label="收款人手持银行卡照片"
                  :required="true"
                  v-model="appealForm.bankCardFront"
                  valueName="bankCardFront"
                  :readonly="verifyFailed && !disabledItem.bankCardFront"
                  :exampleImg="card_eg"
                  @success="uploadSuccess"></uploadImg>
              </el-form-item>
            </el-col>
          </el-row>
          <h4><font class="red">*</font>3、签购单：<span class="red" v-if="verifyFailed && disabledItem.salesSlipImg">（资料未通过审核，请提交正确资料）</span></h4>
          <el-form-item prop="salesSlipImg">
            <uploadImg
              label="图片放大"
              :required="true"
              v-model="appealForm.salesSlipImg"
              :value="appealForm.salesSlipImg"
              valueName="salesSlipImg"
              :readonly="verifyFailed && !disabledItem.salesSlipImg"
              :exampleImg="sale_eg"
              @success="uploadSuccess"></uploadImg>
          </el-form-item>
          <h4><font class="red">*</font>4、代理商风险担保函：<span class="red" v-if="verifyFailed && disabledItem.guaranteeImg">（资料未通过审核，请提交正确资料）</span></h4>
          <el-form-item prop="guaranteeImg">
            <uploadImg
              label="图片放大"
              :required="true"
              v-model="appealForm.guaranteeImg"
              :value="appealForm.guaranteeImg"
              valueName="guaranteeImg"
              :readonly="verifyFailed && !disabledItem.guaranteeImg"
              @success="uploadSuccess"></uploadImg>
            <a class="file-download-button" href="static/风险担保函.doc" download><el-button type="primary" size="small">下载风险担保函示例</el-button></a>
          </el-form-item>
          <!-- <h4><font class="red"></font>5、其他补充资料：</h4>
                    <el-form-item>
                        <upload-files valueName="makeUpData" @success="uploadFileSuccess"></upload-files>
                    </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="submit" v-if="messageForm.auditStatus === 1 || messageForm.auditStatus === 3" :loading="submitLoading">立即提交</el-button>
            <el-button :readonly="messageForm.auditStatus !== 1 && messageForm.auditStatus !== 3" v-else>已提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import uploadImg from '@/components/upload/uploadImg'
import uploadVideoOss from '@/components/upload/uploadVideoOss'
import { riskTicketsDetail, riskTicketsFormDetails, checkNoPassItem, commitRiskTicket } from '@/api/risk'
import { parseAuditStatus } from '@/utils/parseData'
export default {
  name: 'UnfreezeForm',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    requestForm: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    uploadVideoOss,
    uploadImg
  },
  data () {
    return {
      dialogVisible: false,
      // 详情信息
      messageForm: {
        fMerchantName: '',
        fTicketNumber: '',
        fMtlVerifyStatus: '',
        fRiskSource: '',
        fMtlVerifyTimes: '',
        fMerchantId: '',
        fAppealInfoType: '',
        auditSatus: ''
      },
      appealForm: {
        videoUrl: '',
        handheldImg: '',
        bankCardFront: '',
        salesSlipImg: '',
        guaranteeImg: '',
        FMerchantTxnType: ''
      },
      appeal_rules: {
        videoUrl: [{
          required: true,
          message: '请上传视频',
          trigger: 'change'
        }],
        handheldImg: [{
          required: true,
          message: '请上传收款人手持身份证正面（头像面）照片',
          trigger: 'change'
        }],
        bankCardFront: [{
          required: true,
          message: '请上传收款人手持银行卡照片',
          trigger: 'change'
        }],
        salesSlipImg: [{
          required: true,
          message: '请上传签购单',
          trigger: 'change'
        }],
        guaranteeImg: [{
          required: true,
          message: '请上传代理商风险担保函',
          trigger: 'change'
        }]
      },
      disabledItem: {
        videoUrl: false,
        handheldImg: false,
        bankCardFront: false,
        salesSlipImg: false,
        guaranteeImg: false
      }, // 审核失败项
      verifyFailed: false, // 是否审核失败
      submitLoading: false,
      loading: false,
      id_eg: require('../../../../../static/images/id_eg.jpg'),
      card_eg: require('../../../../../static/images/card_eg.jpg'),
      sale_eg: require('../../../../../static/images/sale_eg.jpg')
    }
  },
  computed: {
    fRiskSourceStr () {
      switch (this.messageForm.fRiskSource) {
        case 1: {
          return '微信投诉'
        }
        case 2: {
          return '微信违规'
        }
        case 3: {
          return '支付宝'
        }
        case 4: {
          return '云闪付'
        }
        case 6: {
          return '支付宝告警'
        }
        default: {
          return '乐刷'
        }
      }
    }
  },
  watch: {
    visible (value) {
      this.dialogVisible = value
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    async initData () {
      this.loading = true
      this.dialogVisible = this.visible
      await this.getDetails()
      await this.getDefaultData()
      // 审核不通过查询不合格项
      await this.checkStatus()
      this.loading = false
    },
    async getDetails () {
      var data = {
        ticketNumber: this.requestForm.ticketNumber
      }
      var that = this
      data = qs.stringify(data)
      return new Promise((resolve, reject) => {
        riskTicketsDetail(data).then((data) => {
          if (data.error_code !== '0') {
            this.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
          } else {
            //    赋值给agentForm
            that.messageForm.fMerchantName = data.data.fMerchantName
            that.messageForm.fTicketNumber = data.data.fTicketNumber
            that.messageForm.fMtlVerifyStatus = data.data.fMtlVerifyStatus
            that.messageForm.auditStatus = parseAuditStatus(data.data.fTicketStatus, data.data.fMtlVerifyStatus)
            that.messageForm.fRiskSource = data.data.fRiskSource
            that.messageForm.fMtlVerifyTimes = data.data.fMtlVerifyTimes
            that.messageForm.fMerchantId = data.data.fMerchantId
            that.messageForm.fAppealInfoType = data.data.fAppealInfoType
            that.appealForm.FMerchantTxnType = data.data.fMerchantTxnType
            if (that.messageForm.auditStatus === 3) {
              that.verifyFailed = true
            }
            resolve()
          }
        })
      })
    },
    /**
             * @description 初始化
             */
    async getDefaultData () {
      var data = this.requestForm
      const that = this
      data = qs.stringify(data)
      riskTicketsFormDetails(data).then((data) => {
        if (data.error_code !== '0') {
        } else {
          const info = data.data
          that.evaluation(info)
          console.log(info)
        }
      })
    },
    async checkStatus () {
      if (this.messageForm.auditStatus !== 3) {
        return false
      }
      var data = {
        ticketNumber: this.messageForm.fTicketNumber,
        merchantId: this.messageForm.fMerchantId,
        appealInfoType: this.messageForm.fAppealInfoType
      }
      var that = this
      data = qs.stringify(data)
      return new Promise(function (resolve, reject) {
        checkNoPassItem(data).then((data) => {
          if (parseInt(data.error_code) !== 0) {
            that.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
          } else {
            if (data.data.operationCheckResult.length > 0) {
              // data.data.operationCheckResult.map(function (item) {
              //     let noPassList = item.nonCompliantYeahka;
              //     noPassList.map(function (item2) {
              //         that.disabledItem[item2] = true;
              //     });
              // });
              const noPassList = data.data.operationCheckResult[0].nonCompliantYeahka
              noPassList.map(function (item2) {
                that.disabledItem[item2] = true
              })
            }
            if (data.data.riskCheckResult.length > 0) {
              // data.data.riskCheckResult.map(function (item) {
              //     let noPassList2 = item.nonCompliantYeahka;
              //     noPassList2.map(function (item2) {
              //         that.disabledItem[item2] = true;
              //     });
              // })
              const noPassList2 = data.data.riskCheckResult[0].nonCompliantYeahka
              noPassList2.map(function (item2) {
                that.disabledItem[item2] = true
              })
            }
            resolve()
          }
        })
      })
    },
    /**
             * @description 图片、视频上传成功的回调
             */
    uploadSuccess (data) {
      const name = data.valueName
      this.appealForm[name] = data.path
    },
    submit () {
      let result
      this.$refs.appealForm.validate((valid) => {
        result = valid
        if (!valid) {
          this.$message({
            message: '申诉资料信息有误或不完整，请完善相关信息',
            type: 'warning'
          })
        }
      })
      if (!result && this.submitLoading) {
        return false
      }
      this.submitLoading = true
      let data = this.appealForm
      data = Object.assign(this.appealForm, this.requestForm)
      data = qs.stringify(data)
      commitRiskTicket(data).then((data) => {
        this.submitLoading = false
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'success'
          })
          this.$emit('update:visible', false)
          this.$emit('submit', '')
        }
      }).catch(() => {
        this.submitLoading = false
      })
    },
    //    对象赋值
    evaluation (data) {
      for (const item in data) {
        if (this.appealForm[item] !== undefined) {
          if (typeof data[item] === 'object' && typeof this.appealForm[item] === 'string') {
            this.appealForm[item] = data[item].join(',')
          } else {
            this.appealForm[item] = data[item]
          }
        }
      }
    }
  }
}
</script>

<style scoped>
    h3{
        margin: 30px 0 15px 0;
    }
    p{
      margin: 14px;
    }
    .marginLeft{
        margin-left: 20px;
    }
    .red{
        color:#F56C6C;
        display: inline-block;
    }
    .green{
        color: #77d580;
    }
    .blue{
        color:#409EFF;
    }
    .el-form-item{
        margin-bottom: 30px;
    }
    .smallFont{
        font-size: 12px;
    }
    .formTips{
        line-height: 25px;
        margin-top: 0;
    }
</style>
